import React, { useRef, useState } from "react";

import Modal from "react-bootstrap/Modal";

import useTable from "../useTable";
import axios from "axios";
import { validaMonto, formatMoneda, validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import { ModalIncluirCuenta } from "./modalIncluirCuentaAsiento";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Input, Select, Textarea } from "../../ui/inputs/Input";
import { height } from "@mui/system";

export const ModalAsientoContable = (props) => {
  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CUENTA",
      textAlign: "center",
    },
    {
      id: "nombre",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "rif",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DEBE",
      textAlign: "center",
    },
    {
      id: "nrolicencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "HABER",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtIdMovimiento = useRef();
  const txtDescripcion = useRef();
  const txtFecha = useRef();

  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitadoT, setHabilitadoT] = useState(true);

  const txtDebe = useRef();
  const txtHaber = useRef();
  const cmbTipoAsiento = useRef();
  const txtOrdenPago = useRef();
  const txtEgreso = useRef();
  const txtAsiento = useRef();
  const txtId = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [cuentaContable, setCuentaContable] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [visibleId] = useState("visible");
  const [idmovi, setIdmovi] = useState();

  const [catalogoAsi, setCatalogoAsi] = useState(false);
  const [tablaCata, setTablaCata] = useState(1);
  const [desde, setDesde] = useState(0);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);

  const [values, setValues] = useState();

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const onChange = (e) => {
    if (e.target.name === "motivo") {
      e.target.value = e.target.value;
    } else if (e.target.name === "tipo") {
      setTablaCata(parseInt(e.target.value));
    } else {
      e.target.value = e.target.value;
    }
  };

  const seleccionarCuentaConta = (id) => {
    let endpoint = `${op.conexion
      }/api/contabilidad/ctaconta/?idcuentacontable=${id}&idefiscal=${parseInt(
        idefiscal
      )}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setCuentaContable(response.data[0]);
            setMostrar(true);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (txtDescripcion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Ingresar la descripción del Asiento.",
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    } else if (records.length < 2) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Ingresar al memos dos Cuentas.",
        icono: "informacion",
      });
      sigue = false;
    } else if (
      parseFloat(txtDebe.current.value) !== parseFloat(txtHaber.current.value)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Total del Debe y el Total del Haber deben Coincidir.",
        icono: "informacion",
      });
      sigue = false;
    }
    if (sigue) {
      setDesde(0);
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const seleccionarDetalle = (id) => {
    let endpoint = `${op.conexion
      }/api/contabilidadfis/detalleasiento?idefiscal=${idefiscal}&idasiento=${parseInt(
        id
      )}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            let debe = 0;
            let haber = 0;

            setRecords(response.data);
            for (let i = 0; i < response.data.length; i++) {
              debe =
                parseFloat(debe) + parseFloat(response.data[i].debe.toString());
              haber =
                parseFloat(haber) +
                parseFloat(response.data[i].haber.toString());
            }

            txtDebe.current.value = formatMoneda(
              debe.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            txtHaber.current.value = formatMoneda(
              haber.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let llamado = 0;
    let parametro6 = 0;
    if (txtOrdenPago.current.value.trim().length > 0){
      llamado = 1;
      parametro6 = txtOrdenPago.current.value.trim() === "" ? 0 : parseInt(txtOrdenPago.current.value);
    } else if (txtEgreso.current.value.trim().length > 0){
      llamado = 2;
      parametro6 = txtEgreso.current.value.trim() === "" ? 0 : parseInt(txtEgreso.current.value);
    } else {
      llamado = 3;
      parametro6 = 0;
    }
    
    let body = {
      operacion: props.operacion,
      idasi: txtId.current.value === "" ? 0 : parseInt(txtId.current.value),
      fecha: txtFecha.current.value,
      descripcion: txtDescripcion.current.value.trim().toUpperCase(),
      parametro6:parametro6,
      idefi: idefiscal,
      reverso: 0,
      idasireverso: txtAsiento.current.value === "" ? 0 : parseInt(txtAsiento.current.value),
      llamado:llamado,
      tipoasi: cmbTipoAsiento.current.value,
      detalle: records,
    };



    let endpoint = `${op.conexion}/api/contabilidadfis/crearreversarasiento`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      var datos = [...records];
      var elementos = [];
      var blanquea = [];

      for (let i = 0; i < datos.length; i++) {

        if (cuentaContable.idcuentacontable !== datos[i].idcuentacontable) {
          elementos.push(datos[i]);
        }

      }
      let debe = 0;
      let haber = 0;
      for (let i = 0; i < elementos.length; i++) {
        debe = parseFloat(debe) + parseFloat(records[i].debe.toString());
        haber = parseFloat(haber) + parseFloat(records[i].haber.toString());
      }

      txtDebe.current.value = formatMoneda(debe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
      txtHaber.current.value = formatMoneda(haber.toString().replace(",", "").replace(".", ","), ",", ".", 2);


      setRecords(elementos);
      setCuentaContable();
    } else if (desde === 0) {
      procesarRegistro();
    }
  };

  const blanquear = () => {
    setActivate(false);
    setBody(null);
    setHabilitado(true);
    setHabilitadoT(true);
    setRecords([]);
    setDesde(0);
    setTablaCata(1);

    //txtIdMovimiento.current.setAttribute("disabled", true);
    txtId.current.value = "";
    cmbTipoAsiento.current.value = "";
    txtFecha.current.value = "";
    txtDescripcion.current.value = "";
    txtAsiento.current.value = "";
    txtEgreso.current.value = "";
    txtOrdenPago.current.value = "";
    txtDebe.current.value = "";
    txtHaber.current.value = "";

  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setHabilitado(false);
      txtIdMovimiento.current.setAttribute("disabled", true);
      setTimeout(() => txtDescripcion.current.focus(), 200);
    } else if (op === 2) {
      txtIdMovimiento.current.removeAttribute("disabled");
      setHabilitado(false);
      txtIdMovimiento.current.focus();
    } else if (op === 3) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled");
      txtIdMovimiento.current.focus();
    } else if (op === 4) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled");
      txtIdMovimiento.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    } else if (op === 7) {
      cancelar();
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarRegistro = (id) => {
    setCatalogoAsi(false);
    let campos = "*";
    let nomtab = "asiento";
    let nomid = "idasiento";
    let nomid2 = "idefiscal";

    /*   let id = txtId.current.value; */
    let endpoint = `${op.conexion
      }/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id=${parseInt(
        id
      )}&id2=${idefiscal}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setValues(response.data[0]);
            txtId.current.value = response.data[0].idasiento;
            txtFecha.current.value = moment.utc(response.data[0].fecha).format("YYYY-MM-DD");
            txtDescripcion.current.value = response.data[0].descripcion;
            cmbTipoAsiento.current.value = response.data[0].tipo.toString();
            txtEgreso.current.value = response.data[0].idchequeemitido === null ? "" : response.data[0].idchequeemitido;
            txtOrdenPago.current.value = response.data[0].idordenpago === null ? "" : response.data[0].idordenpago;
            txtAsiento.current.value = response.data[0].idasientoreverso === null ? "" : response.data[0].idasientoreverso;
            setTablaCata(parseInt(response.data[0].tipo));
            seleccionarDetalle(response.data[0].idasiento);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            txtDescripcion.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarPlancuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro(event.target.value);
      } else {
        setValues();
      }
    }
  };

  const gestionarCuenta2 = (op, item) => (e) => {
    e.preventDefault();

    let array = [];
    let array2 = [];
    setOperacion(op);

    if (parseInt(op) === 2) {
      for (let i = 0; i < records.length; i++) {
        if (parseInt(records[i].idplancuenta) === parseInt(item.idplancuenta)) {
          setCuentaContable(records[i]);
        } else {
          array2.push(records[i]);
        }
      }

      setRecords(array2);
      setMostrar(true);
    } else {
      setMensajesino({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Desea Eliminar Esta Cuenta de la Lista.",
        icono: "informacion",
      });
      setCuentaContable(item);
    }
  };

  const gestionarCuenta = (op, data) => (e) => {
    e.preventDefault();
    setIdmovi(data.idmovimientocontable);
    setOperacion(op);
    if (op === 1) {
      setMostrar(true);
    } else if (op === 3) {
      setDesde(1);
      setMensajesino({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Desea Eliminar Esta Cuenta de la Lista.",
        icono: "informacion",
      });
      setCuentaContable(data);
    } else {
      if (props.operacion !== 1) {
        //seleccionarCuentaConta(data.idcuentacontable);
        setCuentaContable(data);
        setMostrar(true);
      } else {
        setCuentaContable(data);  
        setMostrar(true);
      }
    }
  };

  const cargarTabla = (values) => {
    setMostrar(false);

    let sigue = true;
    let debe = 0;
    let haber = 0;
    let arreglo = records;
    let cta = props.operacion === 1 ? values.idplancuenta : values.idcuentacontable;
    let cta1 = 0;
    for (let i = 0; i < records.length; i++) {
      cta1 = props.operacion === 1 ? records[i].idplancuenta : records[i].idcuentacontable;
      if (parseInt(cta) === parseInt(cta1)) {
        if (operacion === 1) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Esta Cuenta ya se encuentra Agregada.",
            icono: "informacion",
          });
          sigue = false;
        } else {
          arreglo[i] = values;
          sigue = false;    
        } 
      }
    }
    if (sigue) {
      //let arreglo = [];

      if (parseInt(tablaCata) === 0) {
        arreglo.push({
          codigocuenta: values.codigocuenta,
          debe: values.debe,
          descripcion: values.descripcion,
          haber: values.haber,
          idplancuenta: values.idplancuenta,
          idcuentacontable: values.idcuentacontable,
        });
      } else {
        arreglo.push({
          codigocuenta: values.codigocuenta,
          debe: parseFloat(values.debe),
          descripcion: values.descripcion,
          haber: parseFloat(values.haber),
          idplancuenta: values.idplancuenta,
          idcuentacontable: values.idcuentacontable,
        });
      }

    }
    setRecords(arreglo);

    for (let i = 0; i < arreglo.length; i++) {
      debe = parseFloat(debe) + parseFloat(arreglo[i].debe.toString());
      haber = parseFloat(haber) + parseFloat(arreglo[i].haber.toString());
    }

    txtDebe.current.value = formatMoneda(
      debe.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtHaber.current.value = formatMoneda(
      haber.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );


  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        //setHabilitado(props.habilitado);
        if (props.operacion === 2 || props.operacion === 1) {
          setHabilitado(false);
        } else {
          setHabilitado(true);
        }


        if (props.operacion !== 1) {
          setHabilitadoT(true);
          seleccionarRegistro(props.idasiento);
        } else {
          setHabilitadoT(false);
          cmbTipoAsiento.current.value = "1";
          setTablaCata(1);
        }

      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Asiento Contable"
            : operacion === 2
              ? "Editar Asiento Contable"
              : operacion === 3
                ? "Eliminar Asiento Contable"
                : "Consultar Asiento Contable"}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0 d-flex flex-wrap align-items-center justify-content-between">
          <div className="col-4 m-0 mb-2 p-0 pr-2" style={{ visibility: visibleId }}>
            <Input
              label="Código:"
              name="idasiento"
              disabled
              onKeyUp={validarPlancuenta}
              onBlur={validarPlancuenta}
              onChange={onChange}
              ref={txtId}
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0">
            <Input
              label="Fecha:"
              type="date"
              name="idcuentabancaria"
              defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
              disabled={habilitado}
              ref={txtFecha}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea
              label="Descripción:"
              style={{ height: 60 }}
              disabled={habilitado}
              name="descripcion"
              onChange={onChange}
              ref={txtDescripcion}
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0 pr-2">
            <Select
              label="Tipo de Asiento:"
              disabled={habilitadoT}
              name="tipo"
              //value={values.tipo.toString()}
              id="tipo"
              onChange={onChange}
              ref={cmbTipoAsiento}
            >
              <option value="0">Apertura</option>
              <option value="1">Movimiento</option>
              <option value="2">Cierre</option>
            </Select>
          </div>
          <div className="col-3 m-0 mb-2 p-0 pr-2">
            <Input
              label="#Orden de Pago:"
              name="idcuentabancaria"
              disabled={habilitado}
              autocomplete="off"
              onKeyUp={validaSoloNumero}
              //onBlur={validarPlancuenta}
              ref={txtOrdenPago}
            />
          </div>
          <div className="col-3 m-0 mb-2 p-0">
            <Input
              label="#Egreso:"
              name="idcuentabancaria"
              disabled
              ref={txtEgreso}
            />
          </div>
          <div className="col-3 m-0 mb-2 p-0 pr-2">
            <Input
              label="Código Asiento a Reversar:"
              name="idcuentabancaria"
              disabled
              ref={txtAsiento}
            />
          </div>
          <div className="col-1 m-0 mb-2 p-0 d-flex align-items-center justify-content-center">
            <PrimaryButton
              icon="fa-plus m-0"
              disabled={habilitado}
              onClick={gestionarCuenta(1, "")}
            ></PrimaryButton>
          </div>
          <div className="col-12 m-0 p-0">
            <TblContainer>
              <TblHead />
              <tbody>
                {records &&
                  records.map((item, index) => (
                    <tr key={index} style={{ padding: "0" }}>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: '70px'
                        }}
                      >
                        {item.codigocuenta}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "left",
                          alignItems: "center",
                          width: '550px'
                        }}
                      >
                        {item.descripcion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "right",
                          alignItems: "center",
                          width: '160px'
                        }}
                      >
                        {formatMoneda(
                          item.debe.toString().replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "right",
                          alignItems: "center",
                          width: '160px'
                        }}
                      >
                        {formatMoneda(
                          item.haber
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>

                      {/* {operacion !== 1 ? (
                        <td
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                          }}
                        >
                          <button
                            onClick={gestionarCuenta2(2, item)}
                            disabled={habilitado}
                            className={
                              "btn btn-sm mx-1 btn-warning rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            onClick={gestionarCuenta2(3, item)}
                            disabled={habilitado}
                            className={
                              "btn btn-sm mx-1 btn-danger rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </td>
                      ) : ( */}
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={gestionarCuenta(4, item)}
                          className={
                            "btn btn-sm mx-1 btn-info rounded-circle"
                          }
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                        <button
                          onClick={gestionarCuenta(2, item)}
                          className={
                            "btn btn-sm mx-1 btn-warning rounded-circle"
                          }
                          disabled={habilitado}
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                        <button
                          onClick={gestionarCuenta(3, item)}
                          className={
                            "btn btn-sm mx-1 btn-danger rounded-circle"
                          }
                          disabled={habilitado}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                      {/* )} */}
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
            {/* <TblPagination /> */}
          </div>
          <div className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
            <div className="col-3 m-0 p-0">
              <Input label="Total Debe:"
                disabled
                align="right"
                ref={txtDebe}
              />
            </div>
            <div className="col-3 m-0 p-0">
              <Input label="Total Haber:"
                disabled
                align="right"
                ref={txtHaber}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onBotones(5)}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnSalir} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <ModalIncluirCuenta
        tabla={parseInt(tablaCata)}
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        operacion={operacion}
        cargarTabla={cargarTabla}
        cuentaContable={cuentaContable}
        cuentas={records}
        idmovi={idmovi}
        asientoId={values ? values.idasiento : 0}
        renderizar={seleccionarRegistro}
      />
    </Modal>
  );
};
